import React, { Fragment } from "react";
import { InputWrapper } from "../../parts/input-wrapper/InputWrapper";
import { FieldModel } from "../../shared/model/field-model";
import { DateOfBirthWrapper } from "../../parts/dob-wrapper/DateOfBirthWrapper";

export interface CollectDobFieldSetProps {
  pageName: string;
  dateOfBirthState: FieldModel;
  onDateOfBirthChange: (value: string) => void;
  onDateOfBirthBlur: (value: string) => void;
  lastNameState: FieldModel;
  onLastNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onLastNameBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
}
export const CollectDobFieldSet = (props: CollectDobFieldSetProps) => {
  const { pageName } = props;
  const { lastNameState, onLastNameChange, onLastNameBlur } = props;
  const { dateOfBirthState, onDateOfBirthChange, onDateOfBirthBlur } = props;
  return (
    <Fragment>
      <InputWrapper
        pageName={pageName}
        name="lastname"
        caption="Last Name"
        fieldState={lastNameState}
        shouldDisplayRequired
        autoCompleteType="family-name"
        onInputChange={onLastNameChange}
        onInputBlur={onLastNameBlur}
      />
      <DateOfBirthWrapper
        pageName={pageName}
        name="dateofbirth"
        caption="Date of Birth"
        fieldState={dateOfBirthState}
        onDateOfBirthChange={onDateOfBirthChange}
        onDateOfBirthBlur={onDateOfBirthBlur}
      />
    </Fragment>
  );
};
